import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { ReactNode } from 'react';

export interface TableHeaderConfig {
    label: string;
    align?: 'left' | 'center' | 'right';
    width?: string | number;
}

export interface BaseTableProps<T = any> {
    headers: TableHeaderConfig[];
    data: T[];
    renderRow: (item: T, index: number) => ReactNode;
    size?: 'small' | 'medium';
    emptyMessage?: string;
    loading?: boolean;
    loadingComponent?: ReactNode;
    className?: string;
    stickyHeader?: boolean;
}

export const BaseTableComponent = <T,>({
    headers,
    data,
    renderRow,
    size = 'small',
    emptyMessage = 'No data available',
    loading = false,
    loadingComponent,
    className,
    stickyHeader = false,
}: BaseTableProps<T>) => {
    if (loading && loadingComponent) {
        return <>{loadingComponent}</>;
    }

    if (!data || data.length === 0) {
        return (
            <TableContainer className={className}>
                <Table size={size} stickyHeader={stickyHeader}>
                    <TableHead>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell key={index} align={header.align} style={{ width: header.width }}>
                                    {header.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={headers.length} align="center">
                                {emptyMessage}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    return (
        <TableContainer className={className}>
            <Table size={size} stickyHeader={stickyHeader}>
                <TableHead>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableCell key={index} align={header.align} style={{ width: header.width }}>
                                {header.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>{data.map((item, index) => renderRow(item, index))}</TableBody>
            </Table>
        </TableContainer>
    );
};

export default BaseTableComponent;
